<template>
	<div class="homeBox">
		<div class="home-image">
			<img src="../../../public/img/icons/login-view.png" />
		</div>
		<div class="login-container">
			<el-form :model="ruleForm" :rules="rules2" status-icon ref="ruleForm" label-position="left"
				label-width="0px" class="demo-ruleForm login-page">
				<h3 class="title">派卜 - 群策</h3>
				<el-form-item prop="loginName">
					<el-input type="text" v-model="ruleForm.loginName" auto-complete="off" placeholder="用户名"
						style="width: 450px;"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"
						style="width: 450px;" @keyup.enter="handleSubmit"></el-input>
				</el-form-item>
				<el-form-item>
					<Vcode :show="showVcode" @success="successVcode" />
				</el-form-item>
				<div class="other-menu">
					<el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox>
					<a href="">忘记密码</a>
				</div>
				<el-form-item style="width:100%;">
					<el-button class="ok-login" type="primary" style="width:100%;" @click="handleSubmit"
						@keyup.enter.native="handleSubmit" :loading="logining">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import http from '../../util/request.js';
import Vcode from "vue-puzzle-vcode";
import qs from 'qs';
export default {
	components: {
		Vcode,
	},
	data() {
		return {
			logining: false,
			ruleForm: {
				loginName: '',
				password: '',
			},
			rules2: {
				loginName: [{
					required: true,
					message: '请输入您的用户名',
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: '请输入密码',
					trigger: 'blur'
				}]
			},
			base: '',
			clickGetValicode: false, // 是否已经通过人机验证
			showVcode: false,
			uuid: '',
			checked: true
		}
	},
	created() {
		this.getCookie();
		this.keyupEnter()
	},
	methods: {
		//键盘回车事件
		keyupEnter() {
			document.onkeydown = e => {
				let body = document.getElementsByTagName('body')[0]
				if (e.keyCode === 13) {
					console.log('enter') // match(此处应填写文件在浏览器中的地址，如 '/home/index')
					this.handleSubmit()
				}
			}
		},
		successVcode(event) {
			this.showVcode = false;
			this.clickGetValicode = true;
			this.handleSubmit();
		},
		handleSubmit() {
			// 进行记住密码操作。
			if (this.checked) {
				// 记住密码
				this.setCookie(this.ruleForm.loginName, this.ruleForm.password, 7);
			} else {
				//移除密码
				this.clearCookie();
			}
			if (!this.clickGetValicode) {
				this.showVcode = true;
				return;
			}
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.logining = true;
					var type = 'course' //新群策
					// var type = 'source' //老群策
					this.$http.get(
						`/api/${type}/sysUser/login?userName=${this.ruleForm.loginName}&password=${this.ruleForm.password}`, {}
					).then((res) => {
						console.log(res.data)
						this.logining = false;
						if (res.data.status == 0) {
							this.$message.success(res.data.msg);
							let userInfo = res.data.data.userInfo;
							console.log(userInfo)
							this.$store.commit('editUserInfo', userInfo);
							this.$store.commit('addRoutes', userInfo.sysAuths);
							this.$store.commit('memberId', userInfo.memberId == null ? 1 : userInfo
								.memberId);
							console.log(this.$store.state.memberId)
							// 存一份在 本地缓存里面
							window.localStorage.setItem('state', JSON.stringify(this.$store.state))
							window.localStorage.setItem('token', res.data.data.token)
							// 先跳转到登录的界面吧
							this.$router.push({
								path: '/home'
							})
						} else {
							this.$message.error(res.data.msg);
						}
					})
						.catch((error) => {
							console.log(error);
							this.logining = false;
							this.$message.error("发生了一些错误:" + error);
						})
				} else {
					return false;
				}
			})
		},
		//设置cookie
		setCookie(c_name, c_pwd, exdays) {
			var exdate = new Date(); //获取时间
			exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
			//字符串拼接cookie
			window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
			window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
		},
		//读取cookie
		getCookie: function () {
			if (document.cookie.length > 0) {
				var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
				for (var i = 0; i < arr.length; i++) {
					var arr2 = arr[i].split('='); //再次切割
					//判断查找相对应的值
					if (arr2[0] == 'userName') {
						this.ruleForm.username = arr2[1]; //保存到保存数据的地方
					} else if (arr2[0] == 'userPwd') {
						this.ruleForm.password = arr2[1];
					}
				}
			}
		},
		//清除cookie
		clearCookie: function () {
			this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
		}
	},

};
</script>

<style scoped>
.login-container {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.login-page {
	margin-top: -160px;
}

label.el-checkbox.rememberme {
	margin: 0px 0px 15px;
	text-align: left;
}

.homeBox {
	width: 100%;
	height: 100%;
	display: flex;
	margin: 0;
	padding: 0;
	overflow: hidden;
}

.home-image {
	height: 100%;
	width: auto;
}

.home-image img {
	width: auto;
	height: 100%;
}

.el-input {
	height: 44px;
	background: rgba(255, 255, 255, 1);
	border-radius: 6px;
}

.other-menu {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.ok-login {
	background: rgba(0, 98, 255, 1);
}

a {
	color: rgba(0, 98, 255, 1);
}
</style>
